import { WorkList, ToolToolbar } from "../../components/ToolPage";
import { useToolScope } from "../../features/toolExperience/useToolScope";
import { useToolListState } from "../../features/toolExperience/useToolListState";
import { useRecentBriefs } from "./useRecentBriefs";
export default function RecentBriefs() {
  const scope = useToolScope();
  const { state, setState } = useToolListState(scope, "briefings", [
    "all",
    "pending",
    "processing",
    "completed",
    "failed",
  ]);
  const query = useRecentBriefs(scope, state);
  return (
    <>
      <ToolToolbar
        search={{
          label: "Search briefs",
          value: state.q,
          onChange: (q) => setState({ q }),
        }}
        filters={
          <select
            aria-label="Brief status"
            value={state.status}
            onChange={(e) => setState({ status: e.target.value })}
          >
            <option value="all">All statuses</option>
            <option value="pending">Pending</option>
            <option value="processing">Running</option>
            <option value="completed">Completed</option>
            <option value="failed">Failed</option>
          </select>
        }
      />
      <p>
        Recent briefs · Up to 50 matching analyses. Open a project for its full
        history.
      </p>
      <WorkList
        state={query.isLoading ? "loading" : query.isError ? "error" : "ready"}
        errorContent={
          <>
            <p>Could not load recent briefs.</p>
            <button type="button" onClick={() => query.refetch()}>
              Try again
            </button>
          </>
        }
        emptyContent="No matching recent briefs."
        items={(query.data || []).map((a) => ({
          id: a.id,
          title: a.input_data?.keyword || "Content brief",
          href: `/briefings/${encodeURIComponent(a.project_id)}?analysis=${encodeURIComponent(a.id)}`,
          metadata: [
            {
              label: "Created",
              value: new Date(a.created_at).toLocaleDateString(),
            },
          ],
          status: {
            label: a.status,
            tone:
              a.status === "failed"
                ? "danger"
                : a.status === "completed"
                  ? "success"
                  : "info",
          },
          actions: [],
        }))}
      />
    </>
  );
}
